export const setLocalStorageItem = (keyName, value) => {
  window.localStorage.setItem(keyName, value);
};

export const getLocalStorageItem = (keyName) => {
  return window.localStorage.getItem(keyName);
};

export const removeLocalStorageItem = (keyName) => {
  window.localStorage.removeItem(keyName);
};
